module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn.8fe3e1a9.mp4";